import * as url from "./url"
import * as ua from "./ua"
import { some } from "lodash"
import { isValidDate } from "../api/gameProps"

export function extend(obj) {
  var length = arguments.length
  if (length < 2 || obj == null) return obj
  for (var index = 1; index < length; index++) {
    var source = arguments[index],
      keys = Object.keys(source),
      l = keys.length
    for (var i = 0; i < l; i++) {
      var key = keys[i]
      if (obj[key] === void 0) obj[key] = source[key]
    }
  }
  return obj
}

/**
 * 获取cgi环境
 * @param sandbox
 * @returns {string}
 */
export function getCgiEnv(sandbox) {
  let env = ""
  if (sandbox == 1) {
    env = "sandbox."
  } else if (sandbox == 2) {
    env = "dev."
  }
  return env
}

/**
 * 解构赋值，将 loginState 变成 cgi 可接受执行
 * @param loginState
 * @returns {{openid: *, openkey: *, session_id: *, session_type: *}}
 * 避免页面有 openid/openkey 重复传递的情况
 */
export function getLoginState(loginState) {
  let { openid, openkey, sessionId: session_id, sessionType: session_type, wxAppid2: wx_appid, qqAppid } = loginState

  return {
    openid,
    openkey,
    session_id,
    session_type,
    wx_appid,
    WxAppid: wx_appid,
    qq_appid: qqAppid || ""
  }
}

/**
 * 解构赋值，将 loginState 变成 H5标准版可接受的形式
 * @param loginState
 * @returns {{openid: *, openkey: *, sessionid: *, sessiontype: *}}
 */
export function getH5PayLoginState(loginState) {
  let { openid, openkey, sessionId: sessionid, sessionType: sessiontype } = loginState

  return {
    openid,
    openkey,
    sessionid,
    sessiontype
  }
}

/**
 * 检测一个对象是否为空
 * 为空返回 true
 * 非空返回 false
 * @param obj
 * @returns {boolean}
 */
export function isObjectEmpty(obj) {
  for (let key in obj) {
    return false
  }
  return true
}

/**
 * 注意这里使用自定义 base64
 * 主要是由于 window.btoa 只能编码 ASCII 码
 * 需要 encode 后再 btoa, 但是某些cgi 不需要 encode
 * 故此重新声明 base64
 * @param input
 * @returns {string}
 */
export function base64encode(input) {
  let keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
  let output = ""
  let chr1, chr2, chr3, enc1, enc2, enc3, enc4
  let i = 0

  let utf8Encode = function (string) {
    string = string.replace(/\r\n/g, "\n")
    let utftext = ""
    for (let n = 0; n < string.length; n++) {
      let c = string.charCodeAt(n)
      if (c < 128) {
        utftext += String.fromCharCode(c)
      } else if (c > 127 && c < 2048) {
        utftext += String.fromCharCode((c >> 6) | 192)
        utftext += String.fromCharCode((c & 63) | 128)
      } else {
        utftext += String.fromCharCode((c >> 12) | 224)
        utftext += String.fromCharCode(((c >> 6) & 63) | 128)
        utftext += String.fromCharCode((c & 63) | 128)
      }
    }
    return utftext
  }
  input = utf8Encode(input)
  while (i < input.length) {
    chr1 = input.charCodeAt(i++)
    chr2 = input.charCodeAt(i++)
    chr3 = input.charCodeAt(i++)
    enc1 = chr1 >> 2
    enc2 = ((chr1 & 3) << 4) | (chr2 >> 4)
    enc3 = ((chr2 & 15) << 2) | (chr3 >> 6)
    enc4 = chr3 & 63
    if (isNaN(chr2)) {
      enc3 = enc4 = 64
    } else if (isNaN(chr3)) {
      enc4 = 64
    }
    output = output + keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4)
  }
  return output
}

/**
 * base64解码，直接用atob解码会乱码
 * @param {} input
 * @returns
 */
export function base64decode(input) {
  let keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
  let output = ""
  let chr1, chr2, chr3
  let enc1, enc2, enc3, enc4
  let i = 0

  const utf8_decode = function (utftext) {
    let string = ""
    let i = 0
    let c, c2, c3
    c = c2 = 0

    while (i < utftext.length) {
      c = utftext.charCodeAt(i)

      if (c < 128) {
        string += String.fromCharCode(c)
        i++
      } else if (c > 191 && c < 224) {
        c2 = utftext.charCodeAt(i + 1)
        string += String.fromCharCode(((c & 31) << 6) | (c2 & 63))
        i += 2
      } else {
        c2 = utftext.charCodeAt(i + 1)
        c3 = utftext.charCodeAt(i + 2)
        string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63))
        i += 3
      }
    } // Whend

    return string
  }

  input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "")
  while (i < input.length) {
    enc1 = keyStr.indexOf(input.charAt(i++))
    enc2 = keyStr.indexOf(input.charAt(i++))
    enc3 = keyStr.indexOf(input.charAt(i++))
    enc4 = keyStr.indexOf(input.charAt(i++))

    chr1 = (enc1 << 2) | (enc2 >> 4)
    chr2 = ((enc2 & 15) << 4) | (enc3 >> 2)
    chr3 = ((enc3 & 3) << 6) | enc4

    output = output + String.fromCharCode(chr1)

    if (enc3 != 64) {
      output = output + String.fromCharCode(chr2)
    }

    if (enc4 != 64) {
      output = output + String.fromCharCode(chr3)
    }
  } // Whend

  output = utf8_decode(output)

  return output
}

export function clone(obj) {
  var str,
    newobj = obj.constructor === Array ? [] : {}
  if (typeof obj !== "object") {
    return
  } else if (window.JSON) {
    str = JSON.stringify(obj)
    //系列化对象
    newobj = JSON.parse(str)
    //还原
  } else {
    for (var i in obj) {
      newobj[i] = typeof obj[i] === "object" ? clone(obj[i]) : obj[i]
    }
  }
  return newobj
}

/**
 * 限制频率 throttle 函数
 * @param func
 * @param wait
 * @param options
 * @returns {function(): *}
 */
export function throttle(func, wait, options) {
  let timeout, context, args, result
  let previous = 0
  if (!options) options = {}

  const later = function () {
    previous = options.leading === false ? 0 : Date.now()
    timeout = null
    result = func.apply(context, args)
    if (!timeout) context = args = null
  }

  const throttled = function () {
    let now = Date.now()

    if (!previous && options.leading === false) previous = now

    let remaining = wait - (now - previous)

    context = this
    args = arguments
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout)
        timeout = null
      }
      previous = now
      result = func.apply(context, args)
      if (!timeout) context = args = null
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining)
    }
    return result
  }

  throttled.cancel = function () {
    clearTimeout(timeout)
    previous = 0
    timeout = context = args = null
  }

  return throttled
}

/**
 * 数组去重
 * @param {} arr
 */
export function uniqueArr(arr) {
  return arr.filter((item, index, arr) => {
    //当前元素，在原始数组中的第一个索引==当前索引值，否则返回当前元素
    return item && arr.indexOf(item, 0) === index
  })
}

/**
 * 取图片右上角颜色
 */
export function getImageColor(imgEl) {
  let canvas = document.createElement("canvas"),
    context = canvas.getContext && canvas.getContext("2d"),
    length,
    data,
    i = -4,
    blockSize = 5,
    count = 0,
    rgb = { r: 0, g: 0, b: 0 }

  canvas.height = imgEl.height
  canvas.width = imgEl.width
  try {
    context.drawImage(imgEl, 0, 0)
    data = context.getImageData(0, 0, 10, 10).data
  } catch (error) {
    console.log(error)
  }
  if (data && data.length) {
    length = data.length
    while ((i += blockSize * 4) < length) {
      ++count
      rgb.r += data[i]
      rgb.g += data[i + 1]
      rgb.b += data[i + 2]
    }
    rgb.r = ~~(rgb.r / count)
    rgb.g = ~~(rgb.g / count)
    rgb.b = ~~(rgb.b / count)
    return rgb
  } else {
    return {
      r: 0,
      g: 0,
      b: 0
    }
  }
}

/**
 * 图片预加载
 * @param {} src
 */
export function preLoadImg(src) {
  let img = new Image()
  img.src = src
  return src
}

/**
 * 监听图片加载完毕
 * @param {} srcArr
 */
export function onLoadedImg(imgArr) {
  let promiseAll = [],
    img = [],
    imgTotal = imgArr.length
  for (let i = 0; i < imgTotal; i++) {
    promiseAll[i] = new Promise(resolve => {
      img[i] = new Image()
      img[i].src = imgArr[i]
      img[i].onload = function () {
        //第i张加载完成
        resolve(img[i])
      }
      img[i].onerror = function () {
        //第i张加载完成
        resolve(img[i])
      }
    })
  }
  return Promise.all(promiseAll)
}

/**
 * 通过 store_config_env 判断的当前的url配置
 * 函数出现背景：多处重复使用此代码
 * @param path
 * @returns {string}
 */
export function getUrlConfigByStoreEnv(path) {
  let storeConfigEnv = url.getParam("store_config_env")

  if (storeConfigEnv && storeConfigEnv > 0) {
    return `//sandbox.pay.qq.com${path}`
  }

  return `//pay.qq.com${path}`
}

/**
 * 获得当前的时间
 * @returns {number}
 */
export function getNowTimeStamp() {
  let nowDate = window._serverTime ? new Date(window._serverTime) : new Date()

  if (!isValidDate(nowDate)) {
    nowDate = new Date()
  }

  return nowDate.getTime()
}

/**
 *判断时间是否在有效期内
 */
export function checkTimeValid(begin, end) {
  let now = getNowTimeStamp()

  let beginTime = new Date(begin).getTime()
  let endTime = new Date(end).getTime()

  return beginTime < now && now < endTime
}

/**
 * 获取url上的 fixedProvideUin 参数，校验是否是QQ号格式，如果不是返回为空
 */
export function getFixedProvideUin() {
  let fixedProvideUin = url.getParam("fixedProvideUin")

  if (/^[1-9]\d{4,10}$/.test(fixedProvideUin)) {
    return fixedProvideUin
  }

  return ""
}

/**
 * 获取页面滚动距离
 */
export function getScrollTop() {
  let supportPageOffset = window.pageXOffset !== undefined
  let isCSS1Compat = (document.compatMode || "") === "CSS1Compat"
  let y = supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop
  return y
}

/**
 * 获取页面高度
 */
export function getClientHeight() {
  let clientHeight = 0
  if (document.body.clientHeight && document.documentElement.clientHeight) {
    clientHeight = Math.min(document.body.clientHeight, document.documentElement.clientHeight)
  } else {
    clientHeight = Math.max(document.body.clientHeight, document.documentElement.clientHeight)
  }
  return clientHeight
}

/**
 * 获取预加载个数
 */
export function getNumInPage() {
  return Math.ceil(getClientHeight() / 200) * 2 + 2
}

export function isWifiEnv() {
  try {
    if (ua.getUserAgent().weixin || ua.getUserAgent().QQ) {
      return navigator.userAgent.indexOf("WIFI") >= 0
    } else {
      return false
    }
  } catch (e) {
    return false
  }
}

export let vidPlayer = {}

/**
 * 获取登录态的账户类型
 * @param {*} loginState 登录态
 * @param {*} defaultType 当无登录态且不在QQ微信内时，兜底选择账户类型
 */
export function getAccountType({ loginState, defaultType = "browser" }) {
  let accountType = ua.getUserAgent().weixin ? "wx" : ua.getUserAgent().QQ ? "qq" : defaultType
  if (loginState && loginState.sessionId == "hy_gameid" && loginState.sessionType == "wc_actoken") {
    accountType = "wx"
  } else if (loginState && (loginState.sessionId == "uin" || ["kp_actoken", "kp_accesstoken"].indexOf(loginState.sessionType) > -1)) {
    accountType = "qq"
  }
  return accountType
}

/**
 * 判断是否是数字
 * @param {*} val
 * return boolean
 */
export function isNumber(val) {
  if (parseFloat(val).toString() == "NaN") {
    return false
  } else {
    return true
  }
}

/**
 * 判断是否已订阅
 * @param {*} val
 * return boolean
 */
export function isSubscribeGroup(groups, subscribeId) {
  if (groups && groups.length && subscribeId) {
    if (typeof subscribeId == "number") {
      subscribeId = subscribeId.toString()
    }
    return (
      groups
        .map(group => {
          return group.FGroupID
        })
        .indexOf(subscribeId) > -1
    )
  } else {
    return false
  }
}

/**
 * 获取分享地址
 * @param {*}
 * url location.href
 * pf 分享pf
 * delParam arr
 */
export function getShareUrl({
  pf,
  delParam = [],
  hasHash = true,
  additionalAddParams = {},
  additionalHashAddParams = null,
  useLocationPathname = false,
  useSpecifyPath = "",
  storeConfig = {},
  delHashParam = []
}) {
  if (!pf) return
  // 登录态分享时需要去掉
  delParam = [
    "pf",
    "code",
    "state",
    "hash",
    "fromMini",
    "openid",
    "openkey",
    "sessionid",
    "sessiontype",
    "qq_appid",
    "wxAppid2",
    "r"
  ].concat(delParam)

  // 如果配置了分享地址，
  if (storeConfig?.shareUrlMap) {
    let obj = url.getStrParams(storeConfig?.shareUrlMap) || {}
    let keys = Object.keys(obj)
    if (keys?.length) {
      keys.forEach(key => {
        if (location?.href?.indexOf(key) > -1) {
          useSpecifyPath = decodeURIComponent(obj[key])
        }
      })
    }
  }

  if (useSpecifyPath) {
    // 支持useSpecifyPath里传参
    if (useSpecifyPath?.split("?")[1]) {
      additionalAddParams = {
        ...additionalAddParams,
        ...url.getStrParams(useSpecifyPath?.split("?")[1])
      }
    }

    useSpecifyPath = useSpecifyPath.split("?")[0]
  }

  let pathname = useLocationPathname ? location.pathname : "/h5/shop.shtml"
  let path = useSpecifyPath ? `${useSpecifyPath}${location.search}` : `${location.origin}${pathname}${location.search}`
  let hash =
    location.href.split("#") && location.href.split("#")[1] && location.href.split("#")[1] != "/" ? location.href.split("#")[1] : ""

  if (delHashParam?.length) hash = url.delParam(delHashParam, hash)
  if (additionalHashAddParams) hash = url.addGetParam(additionalHashAddParams, hash)

  let addParam = {}

  if (url.getParam("tx_chan_type") == "ks") {
    // 快手场景的分享需要调整tx_buyer_id=ks_outer_0&tx_trace_key=3x7ectp2fidcet6
    addParam.tx_buyer_id = "ks_outer_0"
    addParam.tx_trace_key = url.getParam("tx_seller_id")
  }

  if (url.getParam("tx_chan_type") == "ws") {
    addParam.tx_buyer_id = ""
    addParam.tx_trace_key = "ws"
  }

  addParam = {
    ...addParam,
    pf: pf,
    ...additionalAddParams
  }

  if (hash && hasHash) addParam.hash = decodeURIComponent(hash)

  return url.addGetParam(addParam, url.delParam(delParam, path))
}

/**
 * 判断当前路径是否包含某个route
 * @param {*}
 * @returns
 */
export function checkPathIncludeRoute({ path, route = [] }) {
  let checkFlag = false

  route?.length &&
    route.forEach(singleRoute => {
      if (path.indexOf(singleRoute) > -1) {
        checkFlag = true
      }
    })

  return checkFlag
}

/**
 * 随机获取数组中部分元素
 * array
 * count
 */
export function getRandomArrayItem(arr, count) {
  count = arr.length >= count ? count : arr.length
  let shuffled = [...arr]
  let i = arr.length
  let min = i - count
  let temp
  let index
  while (i-- > min) {
    index = Math.floor((i + 1) * Math.random())
    temp = shuffled[index]
    shuffled[index] = shuffled[i]
    shuffled[i] = temp
  }
  return shuffled.slice(min)
}

/**
 * 获取场景值
 */
export function getReqScene() {
  if (ua.getUserAgent().kuaishou) {
    return {
      req_scene: "kuaishou"
    }
  } else {
    return {}
  }
}

// 统一处理上报里resultInfo
export function reportResultInfoHandler(resultInfo = {}) {
  if (typeof resultInfo == "string") {
    return resultInfo
  }

  // 如果是外部带货场景
  let addResultInfo = {}
  if (url.getParam("tx_chan_type") && url.getParam("tx_seller_id")) {
    addResultInfo = {
      shopId: url.getParam("tx_chan_type"),
      pfStructure: ua.getUserAgent().iOS ? "iOS" : "android"
    }
  }

  // 如果是JSAPI调用场景
  if (url.getParam("mode") == "dialog") {
    addResultInfo = {
      ...addResultInfo,
      version: 1
    }
  }

  // 业务希望上传的上报标识adtag
  if (url.getParam("adtag")) {
    addResultInfo = {
      ...addResultInfo,
      adtag: url.getParam("adtag")
    }
  }

  try {
    return {
      ...resultInfo,
      ...addResultInfo
    }
  } catch (error) {
    return {}
  }
}

/**
 * 将 rem 转换成 px
 * @param rem
 * @returns {number}
 */
export function convertRemToPixels(rem) {
  return rem * parseFloat(getComputedStyle(document.documentElement).fontSize)
}

/**
 * 文本过滤
 * return string
 * @param {string} txt
 */
export function handleRecommTxt(txt = "") {
  var reg = /[!"#$%&\\'()*+,\-./:;<=>?@，。?★、…【】《》？“”‘’！\[\]\^_`{|}~]/g
  return txt.replace(reg, "")
}

/**
 * 下单参数过滤
 * return string
 * @param {string} txt
 */
export function checkParamInvalid(txt = "") {
  return txt.match(/[%]/g)
}

/**
 * 判断是否是内部的url
 */
export function checkIfIsInnerUrl(target) {
  if (!/^https?/.test(target)) {
    return false
  }

  try {
    let urlObj = new URL(target)

    if (urlObj.host !== "pay.qq.com") {
      return false
    }

    let validPathname = [
      "/h5/store/index.shtml",
      "/h5/index.shtml",
      "/h5/shop.shtml",
      "/store/experience/index.shtml",
      "/store/test/index.shtml",
      "/store/release/index.shtml"
    ]

    return some(validPathname, item => urlObj.pathname.indexOf(item) !== -1)
  } catch {
    return false
  }
}

/**
 * 获取内部hash router
 * 一般需要再线判断是内部链接（使用checkIfIsInnerUrl函数）之后
 * 再获取hash链接
 * @param target
 * @returns {string}
 */
export function getInnerRouterHash(target) {
  let hash = url.getParam("hash", target)

  if (hash) {
    return decodeURIComponent(hash)
  }

  try {
    let urlObj = new URL(target)

    return urlObj.hash.replace("#", "")
  } catch {
    return ""
  }
}

/**
 * 设置平台是否展示
 * @returns {boolean}
 */
export function shouldDisplayPlatform(ua, pt) {
  let platform = ""

  if (!ua.QQ && !ua.weixin) {
    return false
  }

  if (ua.iOS) {
    platform = "ios"
  } else {
    platform = "android"
  }

  if (ua.QQ) {
    platform += "_qq"
  } else {
    platform += "_wx"
  }

  if (pt) {
    return pt.indexOf(platform) !== -1
  }

  return false
}

/**
 * 解决国外用户时间判断问题
 * @param {} bjTime 北京时间，格式为2022-02-04 00:00:00 或 2022/02/04 00:00:00
 * return 转换为格林威治标准时间时间戳
 */
export function UTC8TimeToTimeStamp(bjTime) {
  return new Date(`${bjTime.replace(/-/g, "/")} GMT+08:00`).getTime()
}

/**
 * 北京时间转换为本地时间格式
 * @param {} bjTime 北京时间，格式为2022-02-04 00:00:00 或 2022/02/04 00:00:00
 * return 转换为本地时间格式2022-2-4 00:00:00
 */
export function UTC8TimeToLocalTimeFormat(bjTime) {
  let date = new Date(UTC8TimeToTimeStamp(bjTime))
  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`
}

// 王者营地中判断传入的角色所属平台
export function getWzydZonePlat(id = "areaId") {
  /**
   * 1:安卓手Q
   * 2:ISO手Q
   * 3:安卓微信
   * 4:ISO微信
   * 5:IOS游客
   * 6:安卓手Q抢先服
   * 7:安卓微信抢先服
   */
  const plat = {}
  const areaId = url.getParam(id)
  const isoArea = ["2", "4", "5"]
  const androidArea = ["1", "3", "6", "7"]
  if (isoArea.includes(areaId)) {
    plat.iOS = true
  }
  if (androidArea.includes(areaId)) {
    plat.android = true
  }
  return plat
}

export function isNonBindPage() {
  return (
    decodeURIComponent(location.hash).indexOf("/bind") == -1 &&
    decodeURIComponent(url.getParam("hash", location.href)).indexOf("bind") == -1 &&
    decodeURIComponent(location.hash).indexOf("/pagedooBind") == -1 &&
    decodeURIComponent(url.getParam("hash", location.href)).indexOf("pagedooBind") == -1
  )
}
